export default {
  createTag: 'Créer une Étiquette',
  createSubtitle: 'Ajouter une nouvelle étiquette pour catégoriser les ressources',
  editTag: 'Modifier l\'Étiquette',
  editTitle: 'Modifier l\'Étiquette',
  editSubtitle: 'Mettre à jour les informations de l\'étiquette',
  createSuccess: 'Étiquette créée avec succès',
  createError: 'Échec de la création de l\'étiquette',
  updateSuccess: 'Étiquette mise à jour avec succès',
  updateError: 'Échec de la mise à jour de l\'étiquette',
  loadError: 'Échec du chargement de l\'étiquette',
  notFound: 'Étiquette introuvable',
  tagsAdmin: {
    form: {
      name: 'Nom',
      namePlaceholder: 'Entrez le nom de l\'étiquette',
      description: 'Description',
      descriptionPlaceholder: 'Entrez la description de l\'étiquette (optionnel)',
      color: 'Couleur',
      preview: 'Aperçu'
    },
    validation: {
      nameRequired: 'Le nom est requis'
    },
    createTitle: 'Créer une Étiquette',
    editTitle: 'Modifier l\'Étiquette',
    deleteTitle: 'Supprimer l\'Étiquette',
    createSuccess: 'Étiquette créée avec succès',
    updateSuccess: 'Étiquette mise à jour avec succès',
    deleteSuccess: 'Étiquette supprimée avec succès',
    createError: 'Échec de la création de l\'étiquette',
    updateError: 'Échec de la mise à jour de l\'étiquette',
    deleteError: 'Échec de la suppression de l\'étiquette',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cette étiquette ? Cette action est irréversible.'
  }
};
